import React, { useEffect } from "react";
import "./entitydashboard.scss";
import GlobalEntitiesTable from "../GlobalEnttitiesTable";

const ChildEntities = ({ childEntitiesData }) => {
  return (
    <div className="child-entities-container">
      <div className="heading-container">
        <h4 className="heading">Child Entities</h4>
        <p className="desc">
          Find all entities listed under this parent company
        </p>
      </div>
      <div className="table-container">
        <GlobalEntitiesTable
          childEntitiesData={childEntitiesData}
          childEntities={true}
        />
      </div>
    </div>
  );
};

export default ChildEntities;
